import { api2 } from '@/public/utils/basePath';
import { cryptoInstance } from '@/public/fetch/index';
// 文章学习海报
export const getArticleBanner = ({ params, query }) => {
    return cryptoInstance.get(`/article/head/${params.userId}`, {
        baseURL: api2,
        params: query
    });
};
// 文章tab列表
export const getArticleTags = ({ params, query }) => {
    return cryptoInstance.get(`/article/tags/${params.userId}`, {
        baseURL: api2,
        params: query
    });
};
// 文章列表
export const getArticleList = ({ params, query }) => {
    return cryptoInstance.get(`/article/list/${params.page}/${params.userId}`, {
        baseURL: api2,
        params: query
    });
};
